import _construct from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/construct.js";
/**
 * Created by commyfeng on 2017/3/27.
 */
/**
 * Created by commyfeng on 2017/3/21.
 */

function toFactory(Class) {
  var Factory = function Factory() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _construct(Class, args);
  };
  Factory.__proto__ = Class;
  Factory.prototype = Class.prototype;
  return Factory;
}
export default toFactory;